var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-switch',{staticClass:"mt-0",attrs:{"label":_vm.criterion.label,"hide-details":"auto"},model:{value:(_vm.criterion.value),callback:function ($$v) {_vm.$set(_vm.criterion, "value", $$v)},expression:"criterion.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }